/**
 * Created by rathompson on 1/19/22
 * File: Instances
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { EmptyStateLayout } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useEffect, useMemo } from 'react'
import FadedLineHeader from '../../../../../common/components/fadedLineHeader/FadedLineHeader'
import { ACTIVATED, ACTIVATING } from '../../../../constants/LabelConstants'
import { LoadInstances } from '../../../../../common/actions/GlobalActions'
import { ARRAY } from '../../../../../common/utils/Utils'
import { PROVISIONING_STATUSES } from '../../../../constants/constants'
import { NO_CLAIMED_LICENSE } from '../../../constants/SubscriptionConstant'
import OnboardingCard from '../OnboardingCard'
import ActivatedInstances from './ActivatedInstances'
import InProgressInstances from './InProgressInstances'
import {
  APP_ID_LOGGING_SERVICE,
  APP_ID_PRISMA_ACCESS,
  APP_ID_DSS_ID,
  APP_ID_PRISMA_SAAS,
  APP_ID_PRISMA_ACCESS_PANORAMA,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_PRISMA_ACCESS_EDITION_ONPREM,
  APP_ID_PRISMA_ACCESS_MOBILE_USERS,
  APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS,
  APP_ID_PRISMA_ACCESS_FOR_CLEAN_PIPE,
  APP_ID_AUTONOMOUS_DEM,
  APP_ID_NET_INTER_CONNECT,
  APP_ID_PRIVATE_APPS,
  APP_ID_PRIVATE_APPS_QTY,
  APP_ID_DATA_TRANSFER,
  APP_ID_DLP,
  APP_ID_IOT,
  APP_ID_CUSTOMER_SUCCESS,
  APP_ID_PRISMA_ACCESS_ONPERM,
  APP_ID_SERVICE_CONNECTION,
  APP_ID_SDWAN,
  APP_ID_DVR,
  APP_ID_PANORAMA,
} from '../../../../../common/constants/GlobalConstants'

const getInstanceWeight = (instance) => {
  switch (instance.app_id) {
    case APP_ID_PRISMA_ACCESS:
    case APP_ID_PRISMA_ACCESS_EDITION:
      return 3
    case APP_ID_SDWAN:
      return 2
    case APP_ID_LOGGING_SERVICE:
    case APP_ID_PRISMA_SAAS:
    case APP_ID_PRISMA_ACCESS_PANORAMA:
    case APP_ID_PRISMA_ACCESS_EDITION_ONPREM:
    case APP_ID_PRISMA_ACCESS_MOBILE_USERS:
    case APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS:
    case APP_ID_PRISMA_ACCESS_FOR_CLEAN_PIPE:
    case APP_ID_AUTONOMOUS_DEM:
    case APP_ID_NET_INTER_CONNECT:
    case APP_ID_PRIVATE_APPS:
    case APP_ID_PRIVATE_APPS_QTY:
    case APP_ID_DATA_TRANSFER:
    case APP_ID_DLP:
    case APP_ID_IOT:
    case APP_ID_CUSTOMER_SUCCESS:
    case APP_ID_PRISMA_ACCESS_ONPERM:
    case APP_ID_SERVICE_CONNECTION:
    case APP_ID_DVR:
    case APP_ID_PANORAMA:
      return 1
    case APP_ID_DSS_ID:
    default:
      return 0
  }
}

const sortInstances = (instanceA, instanceB) => {
  return getInstanceWeight(instanceB) - getInstanceWeight(instanceA)
}

const APP_ID_BLACKLIST = [
  APP_ID_PRISMA_ACCESS,
  APP_ID_DSS_ID
]

const Instances = ({ licenseInstances, licenseDispatch, selectedTreeNode, licenseContext, sgKeyBy, globalTsgId, ...rest }) => {
  useEffect(() => {
    const intervalId = setInterval(() => {
      LoadInstances({
        tsg_id: selectedTreeNode ? selectedTreeNode.id : globalTsgId,
      }, licenseDispatch)
    }, 5 * 1000)
    return () => clearInterval(intervalId)
  }, [globalTsgId, licenseDispatch, selectedTreeNode])

  const instanceMap = useMemo(() => licenseInstances?.filter(instance => Boolean(instance?.extra?.license_hash) && !APP_ID_BLACKLIST.includes(instance.app_id))
    .reduce((map, instance) => {
      const hash = instance.extra.license_hash
      if (!map.hasOwnProperty(hash)) {
        map[hash] = []
      }
      map[hash].push(instance)
      return map
    }, {}), [licenseInstances])

  const activatedInstances = useMemo(() => {
    const copy = Object.assign({}, instanceMap)
    for (const [hash, instances] of Object.entries(copy)) {
      if (!instances.every(({ status, provisioning_status }) => status === 'running' && provisioning_status === PROVISIONING_STATUSES.COMPLETE)) {
        delete copy[hash]
      }
    }
    return Object.entries(copy).map(([hash, instances], index) => (
      <ActivatedInstances
        key={index}
        licenseInstances={instances.sort(sortInstances)}
        selectedTreeNode={selectedTreeNode}
        licenseContext={licenseContext}
        hash={hash}
        sgKeyBy={sgKeyBy}
        tsg_id={selectedTreeNode ? selectedTreeNode.id : globalTsgId}
      />
    ))
  }, [globalTsgId, instanceMap, licenseContext, selectedTreeNode, sgKeyBy])

  const inProgressInstances = useMemo(() => {
    const copy = Object.assign({}, instanceMap)
    for (const [hash, instances] of Object.entries(copy)) {
      if (instances.every(({ status, provisioning_status }) => status === 'running' && provisioning_status === PROVISIONING_STATUSES.COMPLETE)) {
        delete copy[hash]
      }
    }
    return Object.entries(copy).map(([hash, instances], index) => (
      <InProgressInstances
        key={index}
        licenseInstances={instances.sort(sortInstances)}
        selectedTreeNode={selectedTreeNode}
        licenseContext={licenseContext}
        hash={hash}
        sgKeyBy={sgKeyBy}
        tsg_id={selectedTreeNode ? selectedTreeNode.id : globalTsgId}
      />
    ))
  }, [instanceMap, selectedTreeNode, licenseContext, sgKeyBy, globalTsgId])

  return (
    <div>
      {ARRAY.hasArray(inProgressInstances) && (
        <>
          <FadedLineHeader title={ACTIVATING}/>
          {inProgressInstances}
        </>
      )}
      {ARRAY.hasArray(activatedInstances) && (
        <>
          <FadedLineHeader title={ACTIVATED}/>
          {activatedInstances}
        </>
      )}
      {!ARRAY.hasArray(activatedInstances) && (
        <>
          <FadedLineHeader title={ACTIVATED}/>
          <OnboardingCard appearance='activated'>
            <EmptyStateLayout description={NO_CLAIMED_LICENSE} />
          </OnboardingCard>
        </>
      )}
    </div>
  )
}

Instances.propTypes = {}
export default Instances
